module.exports = __webpack_public_path__ + "static/media/iitg-01.ccb710b7.png";